import { ClientSiteModel } from "./clientSite.model";

export enum RoleType {
    Superuser = 'Superuser',
    Admin = 'Admin',
    CAM = 'CAM',
    Client = 'Client'
}

export enum PaygType {
    Managed = 'Managed',
    Guided = 'Guided',
}

export class UserModel {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: string;
  phoneNumber: string;
  isActive: boolean;  
  roles: [{ name: string }];
  primaryRole: string;
  hasPaygFeature: boolean;
  hasPaygUpdateFeature: boolean;
  hasBillingFeature: boolean;
  hasConsumptionFeature: boolean;
  clientSites: ClientSiteModel[] = [];
  status: string;
}
